import { t } from "@/i18n-js/instance";

import type { UpgradePlan } from "../types";

const i18nRoot = "pricing_plans.upgrade_modal";

const CUSTOM_PRICING_INTERVAL_KEY: Record<string, string> = {
  year: "custom_pricing_interval_year",
  biannual: "custom_pricing_interval_biannual",
  quarter: "custom_pricing_interval_quarter",
};

export const getDisplaySubheading = (
  subheading: string,
  isEmailHubOnlyUpgrade?: boolean,
): string => {
  if (isEmailHubOnlyUpgrade) {
    return t("pricing_plans.upgrade_modal.email_hub_value_prop_title");
  }

  return subheading;
};

export const getDisplayName = (
  plan: Partial<UpgradePlan> | undefined,
  marketingHubPlan: Partial<UpgradePlan> | undefined,
): string =>
  plan?.display_name ||
  marketingHubPlan?.display_name ||
  t([i18nRoot, "default_plan_name"]);

export const getAmountWithCurrency = (
  plan: Partial<UpgradePlan> | undefined,
): string => {
  if (plan?.custom_pricing?.display_total) {
    return plan.custom_pricing.display_total;
  }
  const isPlanOnOffer = plan?.plan_coupon?.formatted_discount_percentage;
  return isPlanOnOffer
    ? plan?.plan_coupon?.discounted_monthly_price_with_currency || ""
    : plan?.amount_without_currency || "";
};

export const getDisplayIntervalText = (
  plan: Partial<UpgradePlan> | undefined,
): string => {
  if (plan?.custom_pricing) {
    const intervalKey =
      CUSTOM_PRICING_INTERVAL_KEY[plan.custom_pricing.interval] ??
      "custom_pricing_interval";
    return t([i18nRoot, intervalKey]);
  }
  return (
    plan?.plan_coupon?.interval_abbreviation ||
    plan?.interval_abbreviation ||
    ""
  );
};

export const getDiscountPercentage = (
  plan: Partial<UpgradePlan> | undefined,
): string | null => {
  if (plan?.plan_coupon?.formatted_discount_percentage) {
    return plan.plan_coupon.formatted_discount_percentage;
  }
  return null;
};
